var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconGreenAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 3659"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 3661"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 205",
    cx: 8,
    cy: 8,
    r: 8,
    fill: "#11B9B5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 3660"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line 100",
    x1: 7.91113,
    y1: 3,
    x2: 7.91113,
    y2: 13,
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 101",
    x1: 13,
    y1: 8.2666,
    x2: 3,
    y2: 8.2666,
    stroke: "white",
    strokeWidth: 2
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGreenAdd);
export default __webpack_public_path__ + "static/media/icon_green_add.6842d58d84c69fa6f0bbf33d95fbc463.svg";
export { ForwardRef as ReactComponent };